module.exports = __webpack_public_path__ + "static/Forager5-73cd53e1b07daf454d665a1c7d1d849c.webp";